<template>

    <div>

        <v-layout :style="!noPadding ? 'padding-left: 20px; padding-right: 20px;' : ''">

            <v-flex xs1 v-if="prefix" class="center prefix">

                <slot name="one"/>

            </v-flex>

            <v-flex
                :md10="prefix && !noEndSpacing"
                :md11="(!prefix && !noEndSpacing) || (prefix && noEndSpacing)"
                :md12="!prefix && noEndSpacing"
            >

                <slot name="two"/>

            </v-flex>

            <v-flex
                v-if="active || $slots.help"
                xs1
            >
                <v-layout justify-end :class="{ 'help-btn-pos': inputType !== 'checkbox' }">

                    <slot name="help">
                        <button
                            tabindex="-1"
                            class="help-btn"
                            type="button"
                            @click="showHelp()"
                        >
                            ?
                        </button>
                    </slot>

                </v-layout>

            </v-flex>
            <v-flex xs1 v-else-if="!noEndSpacing"></v-flex>

        </v-layout>

    </div>

</template>

<script>

import { mapActions } from 'vuex';
import EventBus from '../../modules/EventBus';

export default {
    props: {
        widthCorrection: {
            type: Boolean,
            default: false,
        },
        noEndSpacing: {
            type: Boolean,
            default: false,
        },
        oneColumn: {
            type: Boolean,
            default: false,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            required: true,
        },
        prefix: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            required: false,
        },
        white: {
            type: Boolean,
            default: false,
        },
        balesetHelpIconColor: {
            type: Boolean,
            default: false,
        },
        inputType: {
          type: String,
          default: '',
        },
    },
    methods: {
        ...mapActions([
            'updateHelp',
        ]),
        showHelp() {
            EventBus.$emit('show-help');
            this.$store.commit('showHelp');
            this.$store.commit('setMezo', this.name);
            if (this.active) {
                this.updateHelp();
            }
        },
    },
};
</script>
<style scoped>
    .center {
        align-self: center;
    }
    .prefix {
        margin-bottom: 25px;
    }
    .help-btn {
        background-color: var(--v-helpColor-base);
        color: var(--v-helpTextColor-base);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 100%;
        padding-top: 2px;
        font-weight: bold;
    }
    .help-btn:hover {
        background-color: var(--v-activeHelpColor-base);
        color: var(--v-activeHelpTextColor-base);
    }
    .help-btn-pos {
        margin-top: 30px;
        transform: translateY(-50%);
    }
</style>
